import { render, staticRenderFns } from "./EarlyTigers.vue?vue&type=template&id=208247c8&scoped=true&"
import script from "./EarlyTigers.vue?vue&type=script&lang=ts&"
export * from "./EarlyTigers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208247c8",
  null
  
)

export default component.exports